/* tslint:disable */
/* eslint-disable */
/**
 * Leads API
 * API for managing leads (potential customers from external sources)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimulationSanteDto } from './SimulationSanteDto';
import {
    SimulationSanteDtoFromJSON,
    SimulationSanteDtoFromJSONTyped,
    SimulationSanteDtoToJSON,
    SimulationSanteDtoToJSONTyped,
} from './SimulationSanteDto';

/**
 * DTO optimisé pour l'affichage des leads en liste
 * @export
 * @interface LeadListItemDto
 */
export interface LeadListItemDto {
    /**
     * Unique identifier of the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    id?: string;
    /**
     * Plateforme ID the lead belongs to
     * @type {string}
     * @memberof LeadListItemDto
     */
    plateformeId?: string;
    /**
     * Civility code (Mr, Mrs, etc.)
     * @type {string}
     * @memberof LeadListItemDto
     */
    civilityCode?: string;
    /**
     * Last name of the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    lastName?: string;
    /**
     * First name of the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    firstName?: string;
    /**
     * Email address of the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    email?: string;
    /**
     * Phone number of the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    phone?: string;
    /**
     * Birth date of the lead
     * @type {Date}
     * @memberof LeadListItemDto
     */
    birthDate?: Date | null;
    /**
     * Street address
     * @type {string}
     * @memberof LeadListItemDto
     */
    address?: string;
    /**
     * Postal code
     * @type {string}
     * @memberof LeadListItemDto
     */
    postalCode?: string;
    /**
     * City name
     * @type {string}
     * @memberof LeadListItemDto
     */
    city?: string;
    /**
     * Lead acquisition source
     * @type {string}
     * @memberof LeadListItemDto
     */
    source?: string;
    /**
     * Additional comments about the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    comment?: string;
    /**
     * Current status of the lead
     * @type {string}
     * @memberof LeadListItemDto
     */
    status?: string;
    /**
     * Color associated with the status for UI display
     * @type {string}
     * @memberof LeadListItemDto
     */
    statusColor?: string;
    /**
     * ID of the person created from this lead after conversion
     * @type {string}
     * @memberof LeadListItemDto
     */
    convertedPersonId?: string | null;
    /**
     * Identifier of the converted person
     * @type {string}
     * @memberof LeadListItemDto
     */
    convertedPersonIdentifier?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadListItemDto
     */
    assignedBrokerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof LeadListItemDto
     */
    assignedBrokerName?: string | null;
    /**
     * Date and time when the lead was created
     * @type {Date}
     * @memberof LeadListItemDto
     */
    creationTime?: Date;
    /**
     * Date and time of the last modification
     * @type {Date}
     * @memberof LeadListItemDto
     */
    lastModificationTime?: Date | null;
    /**
     * 
     * @type {SimulationSanteDto}
     * @memberof LeadListItemDto
     */
    healthSimulation?: SimulationSanteDto;
}

/**
 * Check if a given object implements the LeadListItemDto interface.
 */
export function instanceOfLeadListItemDto(value: object): value is LeadListItemDto {
    return true;
}

export function LeadListItemDtoFromJSON(json: any): LeadListItemDto {
    return LeadListItemDtoFromJSONTyped(json, false);
}

export function LeadListItemDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadListItemDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'plateformeId': json['plateformeId'] == null ? undefined : json['plateformeId'],
        'civilityCode': json['civilityCode'] == null ? undefined : json['civilityCode'],
        'lastName': json['lastName'] == null ? undefined : json['lastName'],
        'firstName': json['firstName'] == null ? undefined : json['firstName'],
        'email': json['email'] == null ? undefined : json['email'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'birthDate': json['birthDate'] == null ? undefined : (new Date(json['birthDate'])),
        'address': json['address'] == null ? undefined : json['address'],
        'postalCode': json['postalCode'] == null ? undefined : json['postalCode'],
        'city': json['city'] == null ? undefined : json['city'],
        'source': json['source'] == null ? undefined : json['source'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'status': json['status'] == null ? undefined : json['status'],
        'statusColor': json['statusColor'] == null ? undefined : json['statusColor'],
        'convertedPersonId': json['convertedPersonId'] == null ? undefined : json['convertedPersonId'],
        'convertedPersonIdentifier': json['convertedPersonIdentifier'] == null ? undefined : json['convertedPersonIdentifier'],
        'assignedBrokerId': json['assignedBrokerId'] == null ? undefined : json['assignedBrokerId'],
        'assignedBrokerName': json['assignedBrokerName'] == null ? undefined : json['assignedBrokerName'],
        'creationTime': json['creationTime'] == null ? undefined : (new Date(json['creationTime'])),
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : (new Date(json['lastModificationTime'])),
        'healthSimulation': json['healthSimulation'] == null ? undefined : SimulationSanteDtoFromJSON(json['healthSimulation']),
    };
}

export function LeadListItemDtoToJSON(json: any): LeadListItemDto {
    return LeadListItemDtoToJSONTyped(json, false);
}

export function LeadListItemDtoToJSONTyped(value?: LeadListItemDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'plateformeId': value['plateformeId'],
        'civilityCode': value['civilityCode'],
        'lastName': value['lastName'],
        'firstName': value['firstName'],
        'email': value['email'],
        'phone': value['phone'],
        'birthDate': value['birthDate'] == null ? undefined : ((value['birthDate'] as any).toISOString()),
        'address': value['address'],
        'postalCode': value['postalCode'],
        'city': value['city'],
        'source': value['source'],
        'comment': value['comment'],
        'status': value['status'],
        'statusColor': value['statusColor'],
        'convertedPersonId': value['convertedPersonId'],
        'convertedPersonIdentifier': value['convertedPersonIdentifier'],
        'assignedBrokerId': value['assignedBrokerId'],
        'assignedBrokerName': value['assignedBrokerName'],
        'creationTime': value['creationTime'] == null ? undefined : ((value['creationTime']).toISOString()),
        'lastModificationTime': value['lastModificationTime'] == null ? undefined : ((value['lastModificationTime'] as any).toISOString()),
        'healthSimulation': SimulationSanteDtoToJSON(value['healthSimulation']),
    };
}

